import { FilterX, X } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

interface SelectionSummaryProps {
  // Active filters
  status: string[]
  setStatus: (_statuses: string[]) => void
  statusOptions: { value: string; label: string }[]

  shouldArriveAtFrom: string
  setShouldArriveAtFrom: (_date: string) => void

  shouldArriveAtTo: string
  setShouldArriveAtTo: (_date: string) => void

  searchQuery: string
  setSearchQuery: (_searchQuery: string) => void

  handleClearFilters: () => void
}

export const SelectionSummary = ({
  status,
  setStatus,
  statusOptions,
  shouldArriveAtFrom,
  setShouldArriveAtFrom,
  shouldArriveAtTo,
  setShouldArriveAtTo,
  searchQuery,
  setSearchQuery,
  handleClearFilters,
}: SelectionSummaryProps) => {
  // Check if any filters are active
  const hasActiveFilters =
    !status.includes('all') ||
    shouldArriveAtFrom !== '' ||
    shouldArriveAtTo !== '' ||
    searchQuery !== ''

  const handleSearchClear = () => {
    setSearchQuery('')
  }

  const handleClearAll = () => {
    handleClearFilters()
  }

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {/* Search Query Badge */}
      {searchQuery && (
        <Badge className="flex items-center gap-1" variant="secondary">
          <span>Búsqueda: &quot;{searchQuery}&quot;</span>
          <X
            className="h-3 w-3 cursor-pointer hover:text-red-500"
            onClick={handleSearchClear}
          />
        </Badge>
      )}

      {/* Status Filter Badge */}
      {!status.includes('all') && status.length > 0 && (
        <Badge className="flex items-center gap-1" variant="secondary">
          <span>
            Estado:{' '}
            {statusOptions
              .filter((option) => status.includes(option.value))
              .map((option) => option.label)
              .join(', ')}
          </span>
          <X
            className="h-3 w-3 cursor-pointer hover:text-red-500"
            onClick={() => setStatus(['all'])}
          />
        </Badge>
      )}

      {/* Date Range Filter Badge */}
      {(shouldArriveAtFrom || shouldArriveAtTo) && (
        <Badge className="flex items-center gap-1" variant="secondary">
          <span>
            Fecha: {shouldArriveAtFrom || '...'} - {shouldArriveAtTo || '...'}
          </span>
          <X
            className="h-3 w-3 cursor-pointer hover:text-red-500"
            onClick={() => {
              setShouldArriveAtFrom('')
              setShouldArriveAtTo('')
            }}
          />
        </Badge>
      )}

      {/* Clear All Filters Button */}
      {hasActiveFilters && (
        <Button
          className="flex items-center gap-1 text-red-600 hover:bg-red-50 hover:text-red-700"
          onClick={handleClearAll}
          size="sm"
          variant="outline"
        >
          <FilterX className="h-3 w-3" />
          Limpiar todos
        </Button>
      )}
    </div>
  )
}
